import React from 'react';
import people from '../../assets/people.png';
import ai from '../../assets/ai.png';
import './header.css';

const Header = () => (
  <div className="gpt3__header section__padding" id="home">
    <div className="gpt3__header-content">
      <h1 className="gradient__text">askMeCode is an AI Chat Application Build using GPT-3 OpenAI</h1>
      <p>Open AI is an artificial intelligence research laboratory founded in December 2015 by Elon Musk, Open AI has developed a number of open source tools and libraries for machine learning, including TensorFlow, PyTorch, and OpenAI Gym .</p>

      <div className="gpt3__header-content__input">
       <a href="https://ask-me-code-avez.vercel.app/"> <button type="button">Get Started</button></a>
      </div>

      <div className="gpt3__header-content__people">
        <img src={people} />
        <p>1,600 people requested access a visit in last 24 hours</p>
      </div>
    </div>

    <div className="gpt3__header-image">
      <img src={ai} />
    </div>
  </div>
);

export default Header;
